import { createFileRoute } from "@tanstack/react-router";
import { MyProfilePage } from "./-components/MyProfilePage";
import { userInfoQueryOptions } from "@/lib/queries/auth";

export const Route = createFileRoute("/_app/my-profile/")({
  component: RouteComponent,
  loader({ context: { queryClient } }) {
    return queryClient.ensureQueryData(userInfoQueryOptions);
  },
  staticData: {
    title: "My Profile",
  },
});

function RouteComponent() {
  return <MyProfilePage />;
}
